import type { ResolvedMonospaceSingleRelationField } from '#layers/data-model/types/schema/resolved-schema';
import { getRelationFieldPresentationDefaults, isM2M, isRelationToMonospaceFiles, ProjectCollectionIds, resolveFieldInputPresentation } from '#layers/data-model';

export function getSingleRelationFieldInputBlockOptions(field: ResolvedMonospaceSingleRelationField): {
	block: string;
	props?: Record<string, any>;
} {
	const defaults = getRelationFieldPresentationDefaults(field).input;
	return resolveFieldInputPresentation(defaults, field.meta);
}

export function isFileThumbnailField(field: ResolvedMonospaceSingleRelationField) {
	return field.apiName === '$thumbnail' && field.collectionId === ProjectCollectionIds.MonospaceFile;
}

export function isToOneFileRelation(field: ResolvedMonospaceSingleRelationField) {
	return !field.isList && !isM2M(field) && isRelationToMonospaceFiles(field);
}
